import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center flex-col gap-2 items-center md:justify-between md:flex-row py-4 border-t-2 border-footerBorderColor" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold font-size-16" }, "© 2022 KKiaPay", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kkiapay = _resolveComponent("kkiapay")!
  const _component_container = _resolveComponent("container")!

  return (_openBlock(), _createBlock(_component_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_kkiapay),
        _hoisted_2
      ])
    ]),
    _: 1
  }))
}